import React, { FC, ReactElement } from "react";
import useMinWait from "Hooks/useMinWait";
import LoadingAnimation from "./LoadingAnimation";

type Props = {
  isLoading?: boolean;
  waitTime?: number;
  awaitComponent: ReactElement;
  kind: "page" | "table" | "chart";
};

const DPComponentLoader: FC<Props> = ({
  isLoading = false,
  waitTime = 500,
  awaitComponent = null,
  kind,
}) => {
  const isWaiting = useMinWait(waitTime);

  if (isWaiting) return null; // unless wait is noticeable, don't show
  return isLoading ? <LoadingAnimation kind={kind} /> : awaitComponent;
};

export default DPComponentLoader;
